import React, { Component } from 'react'
import { Authenticated } from 'react-admin'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CertificationIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';

import CompanyTable from './CompanyTable';
import CompanyFilter from './CompanyFilter';
import ProyectoCompanyTable from './ProyectoCompanyTable';
import InstalacionesCompanyTable from './InstalacionesCompanyTable';
import CompletitudInstalaciones from './CompletitudInstalaciones'
import CompletitudProyectos from './CompletitudProyectos'
import CompletitudTipoInstalacion from './CompletitudTipoInstalacion'
import { reportesServiceProyecto } from '../../services/reportes.service.proyecto';


const styles = theme => ({
  title : {
    marginBottom: '20px',
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    fontSize: 23,
    '& svg' : { color: '#019EAC', paddingRight : 10 }
  },
  root: {
    // overflow: 'visible'
  },
  snackbarWarning: {
    backgroundColor: theme.palette.error.light,
  }
})

class Reportes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      empresa: false,
      currentPage: 1,
      search: "",
      loading: false,
      perPage: 10,
      proyectos: [],
      proyectosCompany: [],
      proyectosInstalaciones: [],
      visibleIds: [],
      value: '',
      // Installation pagination
      insCurrentPage: 1,
      insPerPage: 10,
      insTotalResults: 0,

      tipoInstalacion: false,
      tipoInstalacionChoices: [],
      datoTecnico: false,
      datoTecnicoChoices: [],
      dataSetTipoInstalacion: [],

      sortColumn: "id",
      sortDirection: "ASC",

      totalResults: 0,
      saving: false,
      snackbarOpen: false,
      dataSetCompletitud: null,
      idProyecto: null,
      filterActive: false
    }

    this.fetchResults = this.fetchResults.bind(this);
    this.debouncedThing = _.debounce(this.doTheThing, 1000)
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerPageChange = this.handlePerPageChange.bind(this);
    this.handlePageChangeInstallations = this.handlePageChangeInstallations.bind(this);
    this.handlePerPageChangeInstallations = this.handlePerPageChangeInstallations.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this)
}

    componentDidMount() {
        
        const filterParams = {
          pagination: {
              page: 1,
              perPage: 10,
          },
          sort: { field: 'id', order: 'ASC' },
          filter: { search: '' }
        }

        this.setState({ loading: true })
        reportesServiceProyecto.proyectosGeneral(filterParams)
        .then(({ proyectos, totalResults }) => {
            this.setState({ proyectos, totalResults,  loading: false })
          })
          .catch( error => { 
              console.log(error) 
              throw error
          })

        this.setState({ loading: true })
        reportesServiceProyecto.proyectosGeneralCompanyFilter()
        .then(({ proyectos }) => {
            let arr = []
            proyectos.forEach( (x) =>  {
                const { id, nup } = x

                let obj = { key: id, value: nup, text: nup}
                arr.push(obj)
            })

            this.setState({ proyectosList: arr })
          })
          .catch( error => { 
              console.log(error) 
              throw error
          })

        this.setState({ isPendingCalidadTipoInstalacion: true })
        reportesServiceProyecto.calidadTipoInstalacion()
            .then(( dataSetTipoInstalacion ) => { 
                this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
            })
            .catch( error => { 
                console.log(error) 
                throw error
            })
    }

    componentDidUpdate( nextProps, nextState, snapshot )  {
        
      if(this.state.value != nextState.value){
            if(this.state.value == ''){
                this.setState({ id: null })
                this.setState({ filterActive: false })

                this.setState({ isPendingCalidadTipoInstalacion: true })
                reportesServiceProyecto.calidadTipoInstalacion()
                    .then(( dataSetTipoInstalacion ) => { 
                        this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
                    })
                    .catch( error => { 
                        console.log(error) 
                        throw error
                })
            }
            else 
            {
              let instalationFilterParams = {
                pagination: {
                    page: this.state.insCurrentPage,
                    perPage: this.state.insPerPage,
                },
                sort: {
                    field: this.state.sortColumn,
                    order: this.state.sortDirection
                },
                filter: { search: '' }
                }

                let id
                this.state.proyectosList.forEach((x, i, v) => {
                    const { key, value} = x 
                    if(this.state.value == value)
                    {
                        id = key
                        this.setState({ idProyecto: id })
                        this.setState({ filterActive: true })
                    }
                })

                this.setState({ loading: true })
                reportesServiceProyecto.proyectosGeneralCompanyId(id)
                .then(({ proyectos, totalResults }) => {
                    this.setState({ proyectos, totalResults,  loading: false })
                })
                  .catch( error => { 
                      console.log(error) 
                      throw error
                  })

                this.setState({ loading: true })
                reportesServiceProyecto.proyectosGeneralCompanyFilter2(id)
                .then( ({ proyectosCompany, totalResults }) => { 
                    this.setState({ proyectosCompany, totalResults,  loading: false })
                })

                this.setState({ loading: true })
                reportesServiceProyecto.proyectosGeneralCompanyFilter3(id, instalationFilterParams)
                .then( ({ proyectosInstalaciones, insTotalResults }) => { 
                    this.setState({ proyectosInstalaciones, insTotalResults,  loading: false })
                })

                this.setState({ isPendingCalidadTipoInstalacion: true })
                reportesServiceProyecto.calidadTipoInstalacion(id)
                    .then(( dataSetTipoInstalacion ) => { 
                        this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
                    })
                    .catch( error => { 
                        console.log(error) 
                        throw error
                    })
            }
      }
    }

  handlePerPageChange(newPerPage) {
    this.setState({
      perPage: newPerPage,
      visibleIds: []
    }, () => this.fetchResults())
  }

  handlePerPageChangeInstallations(newPerPage) {
    this.setState({
      insPerPage: newPerPage,
      visibleIds: []
    }, () => this.fetchResultsInstallations())
  }

  handleSearchChange = () => (event, value) => {
    this.debouncedThing(value.searchQuery)
  }

  handleChange = () => (event, value) => {
      this.setState({ value: value.value })
  }

  handleClear() {
    this.setState({ value: '' }, () => {
      this.debouncedThing(this.state.value)
    })

    this.setState({ 
      insTotalResults: 0,
      insCurrentPage: 1,
    })
  }

  doTheThing(value) {
    this.setState({
      search: value,
      totalResults: 0,
      currentPage: 1,
    }, () => this.fetchResults())
  }

  fetchResults() {
    const {search} = this.state
    const filter = {};
      
    if (!!search) { filter["search"] = search }
        const filterParams = {
        pagination: {
            page: this.state.currentPage,
            perPage: this.state.perPage,
        },
        sort: {
            field: this.state.sortColumn,
            order: this.state.sortDirection
        },
        filter
        }

        this.setState({ loading: true })
        reportesServiceProyecto.proyectosGeneral(filterParams)
        .then( ({ proyectos, totalResults }) => { 
            this.setState({ proyectos, totalResults,  loading: false })
        })
  }

  fetchResultsInstallations() {
      const filterParams = {
        pagination: {
            page: this.state.insCurrentPage,
            perPage: this.state.insPerPage,
        }
      }
        this.setState({ loading: true })
        reportesServiceProyecto.proyectosGeneralCompanyFilter3(this.state.idProyecto, filterParams)
        .then( ({ proyectosInstalaciones, insTotalResults }) => { 
            this.setState({ proyectosInstalaciones, insTotalResults, loading: false })
        })
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => this.fetchResults())
  }

  handlePageChangeInstallations(newPage) {
    this.setState({ insCurrentPage: newPage }, () => this.fetchResultsInstallations())
  }

  render() {
    const { dataSetTipoInstalacion } = this.state
    const { classes } = this.props

    return (
      <Authenticated
        authParams={{ required: false, roles: ["admin", "coordinador", "externo", "coordinado"] }}
        location={this.props.location}
      >
          <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.title}>
                <CertificationIcon /> Reportes Proyectos
              </Typography>
                <Grid>
                    <CompanyFilter
                        value={this.state.value}
                        options = {this.state.proyectosList}
                        handleSearchChange = {this.handleSearchChange}
                        handleChange = {this.handleChange}
                        handleClear = {this.handleClear}
                    />
                </Grid>
              <Grid>
                <Grid>
                  <CompanyTable
                    proyectos={this.state.proyectos}
                    id={this.state.idProyecto}
                    total={this.state.totalResults}
                    page={this.state.currentPage}
                    perPage={this.state.perPage}
                    isLoading={this.state.loading}
                    onPageChange={this.handlePageChange}
                    onPerPageChange={this.handlePerPageChange}
                    value={this.state.value}
                  />
                </Grid>
                  <br/>
                <Grid>
                {this.state.filterActive &&
                  <ProyectoCompanyTable
                    proyectos={this.state.proyectosCompany}
                    id={this.state.id}
                    total={this.state.totalResults}
                    page={this.state.currentPage}
                    perPage={this.state.perPage}
                    isLoading={this.state.loading}
                    onPageChange={this.handlePageChange}
                    onPerPageChange={this.handlePerPageChange}
                    value={this.state.value}
                  />}
                </Grid>
                  <br/>
                <Grid>
                  {this.state.filterActive &&
                  <InstalacionesCompanyTable
                    proyectos={this.state.proyectosInstalaciones}
                    id={this.state.id}
                    total={this.state.insTotalResults}
                    page={this.state.insCurrentPage}
                    perPage={this.state.insPerPage}
                    isLoading={this.state.loading}
                    onPageChange={this.handlePageChangeInstallations}
                    onPerPageChange={this.handlePerPageChangeInstallations}
                    value={this.state.value}
                  />}
                </Grid>
                  <br/>
                <Grid>
                  {this.state.proyectos && !this.state.filterActive && <CompletitudProyectos type='completitud'
                    dataset={{
                      isPending: this.state.loading,
                      data: this.state.proyectos
                    }}
                  />}
                </Grid>
                <Grid>
                  {dataSetTipoInstalacion && this.state.filterActive && <CompletitudTipoInstalacion type='completitud'
                    dataset={{
                      isPending: this.state.isPendingCalidadTipoInstalacion,
                      data: dataSetTipoInstalacion
                    }}
                  />}
                </Grid>
                <Grid>
                  {dataSetTipoInstalacion && <CompletitudInstalaciones
                    divId={'completitud-tipo-instalacion-general'}
                    title={"Calidad General por Tipo de Instalación"}
                    dataset={{
                      isPending: this.state.isPendingCalidadTipoInstalacion,
                      data: dataSetTipoInstalacion
                    }}
                  />}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
      </Authenticated>
    ) 
  }
}

export default withRouter(withStyles(styles)(Reportes))
